@app.service 'SpreeAuthenticationService', ($http, csConfig) ->

  @logout = ->
    $http.get("#{csConfig.spreeEndpoint}/auth_logout", { withCredentials: true })

  this
